module.exports = __webpack_public_path__ + "static/media/contact-info-icon-active.9c87e481.svg";